import dayjs from 'dayjs'
import { KeepUser, KeepUsers } from 'src/models/User'
import useSWR, { SWRConfiguration } from 'swr'
import { ApiClient, fetcher } from './client'
import { GET_KEEPS, postKeeps, POST_KEEPS } from './endpoints'
import { KeepCompanies, KeepCompany } from './types/keep'

const keepFetcher = async (url: string) => {
  const data: KeepCompanies = await fetcher(url)
  return {
    items: data.items.map((item) => toKeepUser(item)),
    totalCount: data.totalCount,
    totalPages: data.totalPages,
    onePageDisplayItems: data.onePageDisplayItems,
  }
}

export const useKeeps = (
  page: number = 1,
  config?: Partial<SWRConfiguration>,
) => useSWR<KeepUsers>(`${GET_KEEPS}?page=${page}`, keepFetcher, config)

export const postKeep = async (id: number) => {
  const formData = new FormData()
  formData.append('target_company_id', String(id))
  const res = await ApiClient.post(POST_KEEPS, formData)
  return res
}

export const deleteKeep = async (id: number) => {
  const formData = new FormData()
  formData.append('_method', 'DELETE')
  const res = await ApiClient.post(postKeeps(id), formData)
  return res
}

const toKeepUser = (data: KeepCompany): KeepUser => ({
  id: data.id,
  roomUrl: data.roomUrl,
  isActive: data.isActive,
  isNew: data.isNew,
  isCertified: data.isCertified,
  name: data.adminName || '',
  companyName: data.name || '',
  position: data.position || '',
  capital: data.capitalText || '',
  businessType: data.typeOfBusiness?.join('、') || '',
  foundedOn: data.foundedAt ? `${dayjs(data.foundedAt).year()}` : undefined,
  imageSrc:
    typeof data.imageUrl === 'string'
      ? data.imageUrl
      : data.imageUrl?.medium?.url || data.imageUrl?.url,
  numberOfEmployees: data.employeeNumberText,
  prefecture: data.prefecture,
  storyUrl: data.storyUrl,
  hpUrl: data.hpUrl,
  fbUrl: data.fbUrl,
  kept: data.kept,
  messageAvailable: data.messageAvailable,
  adminAges: data.adminAges,
})
